import { Button} from '@bbri/ui';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import React from 'react';

export const SubmissionNameDialog = ({
  t,
  formService,
  isVisible,
  name,
  onChange,
  onSave,
  onClose,
  isOnMobile
}) => (
  <Dialog
    header={formService.t(t, "ui_submission_name_dialog_header", true)}
    visible={isVisible}
    modal
    focusOnShow={false}
    onShow={() => (document.activeElement as HTMLElement).blur()}
    style={isOnMobile ? { width: "95%" } : { width: "450px" }}
    onHide={onClose}
  >
    <InputText
      style={{ width: "100%"}}
      value={name}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
    >
    </InputText>

    <div style={{ display: "flex", marginTop: "10px" }}>
      <Button onClick={onSave}>{formService.t(t, "save", false)}</Button>
    </div>
  </Dialog>
);

